import Vue from "vue";

export const barramento = new Vue({ name: "vue-camapanha-apuracao" });
